import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/privateK8Clusters/index.tsx");
